import React, { useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import { InventoryModalContext } from '../../InventoryModalContext';
import { InventoryForm } from '../InventoryForm';
import { PurchaseFields } from '../PurchaseFields';
import { OperatingSystemFormField } from '../FormFields/OperatingSystemFormField';
import { SerialNumberFormField } from '../FormFields/SerialNumberFormField';

type Props = {
  category?: string;
};

export const ElectronicDeviceForm: React.FC<Props> = () => {
  const { isExpanded = false } = useContext(InventoryModalContext);

  return (
    <React.Fragment>
      <Row>
        <Col className="px-lg-2" lg={isExpanded ? 6 : 12}>
          <InventoryForm />
        </Col>
        <Col className="px-lg-2 mb-4" lg={isExpanded ? 6 : 12}>
          <OperatingSystemFormField />
        </Col>
        <Col className="px-lg-2" lg={isExpanded ? 6 : 12}>
          <SerialNumberFormField />
        </Col>
      </Row>
      <PurchaseFields />
    </React.Fragment>
  );
};
